// This is the declaration of the expected data structure

let dataStructure = {

  lessonStructure: {
    id: null,
    planType: "lesson",
    attribute: "NVSDemoCoaching",
    data: {
      title: null,
      body: null,
      imageLink: null,
      options: {
        startDay: null,
        primaryIcon: null,
        primaryLink: null,
        primaryText: null,
        secondaryIcon: null,
        secondaryLink: null,
        secondaryText: null,
        belongsToTemplate: []
      },
      shortName: null,
      deletedStatus: false,
      lastModifiedTime: null,
      lastModifiedByUser: null,
    }
  },
  actionStructure: {
    id: null,
    planType: "action",
    attribute: "NVSDemoCoaching",
    data: {
      title: null,
      body: null,
      options: {
        startDay: null,
        endDay: null,
        reminder: {
          title: null,
          body: null,
          isDaily: false,
          alarmTime: null,
          alarmState: false,
          alarmDateTime: null
        },
        belongsToTemplate: [],
        userTracking: {
          status: true,
          isDaily: false
        }
      },
      shortName: null,
      deletedStatus: false,
      lastModifiedTime: null,
      lastModifiedByUser: null,
    }
  },

  actionPlanStructure: {
    id: null,
    planType: "action",
    attribute: "NVSDemoCoaching",
    data: {
      title: null,
      deletedStatus: false,
      childPlans: []
    }
  },

  lessonPlanStructure: {
    id: null,
    planType: "lesson",
    attribute: "NVSDemoCoaching",
    data: {
      title: null,
      deletedStatus: false,
      childPlans: []
    }
  },

  //Note to be used to validate on the patient side!
  profilePlanStructure: {
    id: null,
    planType: "profile",
    attribute: "NVSDemoCoaching",
    data: {
      name: null,
      language: null,
      medgateId: null,
      objective: [],
      startDate: null,
      endDate: null,
      coachNotes: null,
      consent: {
        studyConsent: false,
        coachingConsent: false
      },
      docAppt: {
        timestamp: null,
        reschedule: false
      },
      coachAppt: {
        timestamp: null,
        reschedule: false
      },
      coachMessage: {
        title: null,
        body: null,
        lastModifiedTime: null
      },
      lastSeenTime: null,
      dailyTracking: [],
      oneTimeTracking: [],
      notTrackable: [],
      lastModifiedTime: null,
      lastModifiedByUser: null,
      deletedStatus: false
    }
  },

  patientStructure: {
    id: null,
    userId: null,
    consent: false,
    profile: {
      id: null,
      planType: "profile",
      attribute: "NVSDemoCoaching",
      data: {
        name: null,
        language: null,
        medgateId: null,
        objective: [],
        startDate: null,
        endDate: null,
        coachNotes: null,
        consent: {
          studyConsent: false,
          coachingConsent: false
        },
        docAppt: {
          timestamp: null,
          reschedule: false
        },
        coachAppt: {
          timestamp: null,
          reschedule: false
        },
        coachMessage: {
          title: null,
          body: null,
          lastModifiedTime: null
        },
        lastSeenTime: null,
        dailyTracking: [],
        oneTimeTracking: [],
        notTrackable: [],
        lastModifiedTime: null,
        lastModifiedByUser: null,
      }
    },
    userPlans: [],
    data: {}
  }

};

export default dataStructure;



// WEBPACK FOOTER //
// ./src/validation/dataStructure.js